import { useMemo } from 'react'
import { Dialog } from '@blueprintjs/core'
import { Colors } from 'design/colors'
import { CStore, StoredTag, TagDefinition } from 'cstore/cstore'

type Item = {
  tagId: number
  tagName: string
  tagUnits: string
  tag: StoredTag
  def?: TagDefinition
}

export const CStoreDisplay = (props: { cstore: CStore; onClose: () => void }) => {
  const { cstore, onClose } = props

  const items: Item[] = useMemo(() => {
    return cstore.storedTags
      .filter((tag) => !tag.isTerminator())
      .map((tag: StoredTag): Item => {
        const def = tag.getTagDefinition(cstore.allTags)
        return {
          tagId: tag.tagId,
          tagName: def?.name ?? '',
          tagUnits: def?.units ?? '',
          tag,
          def
        }
      })
  }, [cstore])

  return (
    <Dialog
      title="Configuration Items (cstore)"
      isOpen={true}
      onClose={onClose}
      style={{
        backgroundColor: Colors.LIGHT_GREEN,
        color: Colors.WHITE,
        minWidth: '700px'
      }}
      className="cstore-dialog"
    >
      <style>
        {`
                .cstore-dialog .bp5-dialog-header {
                    background-color: rgba(26,42,35,1);
                    padding: 10px;
                }
                .cstore-dialog .bp5-dialog-header .bp5-heading {
                    color: white;
                    font-size: 18px;
                    font-weight: bold;
                    padding-left: 20px;
                }
                `}
      </style>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          margin: '10px 30px 30px 30px'
        }}
      >
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead style={{ borderBottom: '1px solid #555555' }}>
            <tr>
              <th scope="col" style={{ textAlign: 'start', paddingBottom: '8px' }}>
                Tag ID
              </th>
              <th scope="col" style={{ textAlign: 'start', paddingBottom: '8px' }}>
                Name
              </th>
              <th scope="col" style={{ textAlign: 'start', paddingBottom: '8px' }}>
                Value
              </th>
              <th scope="col" style={{ textAlign: 'start', paddingBottom: '8px' }}>
                Units
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item: Item) => (
              <tr key={item.tagId} style={{ borderBottom: '1px solid #555555' }}>
                <td style={{ padding: '2px' }}>{item.tagId}</td>
                <td style={{ padding: '2px' }}>{item.tagName}</td>
                <td style={{ padding: '2px' }}>{item.tag.getData()?.toString()}</td>
                <td style={{ padding: '2px' }}>{item.tagUnits}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Dialog>
  )
}
